/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 全局注册组件
 */
import pageDialog from "@/jh/components/baseDialog/pageDialog.vue";
import selectColumnDialog from "@/jh/components/baseDialog/selectColumnDialog.vue";
import searchDialog from "@/jh/components/baseDialog/searchDialog.vue";
import treeLayout from "@/components/treeLayout/treeLayout.vue";
import baiduMaps from "@/components/baiduMap/index.vue";
import cardUpload from "@/components/upload/index.vue";
import jhEditor from "@/components/editor/index.vue";
import productionFile from "@/components/productionFile/index.vue";
import outSheep from "@/components/outSheep/index.vue";
import breedVaccine from "@/components/breedVaccine/index.vue";
import everyDay from "@/components/everyDay/index.vue";
import chart from "@/components/charts/index";
import fileUpload from "@/components/upload/fileUpload.vue";
function plugin(Vue) {
  if (plugin.installed) {
    return;
  }
  Vue.component("pageDialog", pageDialog);
  Vue.component("selectColumnDialog", selectColumnDialog);
  Vue.component("searchDialog", searchDialog);
  Vue.component("treeLayout", treeLayout);
  Vue.component("baiduMaps", baiduMaps);
  Vue.component("card-upload", cardUpload);
  Vue.component("jh-editor", jhEditor);
  Vue.component("production-file", productionFile);
  Vue.component("outSheep", outSheep);
  Vue.component("breedVaccine", breedVaccine);
  Vue.component("everyDay", everyDay);
  Vue.component("jh-chart", chart);
  Vue.component("fileUpload", fileUpload);
}
export default plugin;



// WEBPACK FOOTER //
// ./src/components/index.js